/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CreateTopUpCheckoutSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type CreateTopUpCheckoutRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type CreateTopUpCheckoutSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateTopUpCheckoutSecurity$outboundSchema: z.ZodMiniType<
  CreateTopUpCheckoutSecurity$Outbound,
  CreateTopUpCheckoutSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createTopUpCheckoutSecurityToJSON(
  createTopUpCheckoutSecurity: CreateTopUpCheckoutSecurity,
): string {
  return JSON.stringify(
    CreateTopUpCheckoutSecurity$outboundSchema.parse(
      createTopUpCheckoutSecurity,
    ),
  );
}

/** @internal */
export type CreateTopUpCheckoutRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateTopUpCheckoutRequest$outboundSchema: z.ZodMiniType<
  CreateTopUpCheckoutRequest$Outbound,
  CreateTopUpCheckoutRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function createTopUpCheckoutRequestToJSON(
  createTopUpCheckoutRequest: CreateTopUpCheckoutRequest,
): string {
  return JSON.stringify(
    CreateTopUpCheckoutRequest$outboundSchema.parse(createTopUpCheckoutRequest),
  );
}
